import React, { useContext } from 'react';
import EmailFillIcon from 'components/lib/icons/email_fill_icon';
import FloorboardRow from './floorboard_row';
import LiveboardContext from 'components/liveboards/contexts/liveboard_context.jsx';

export default function EmailRow() {
  const { channel, sla } = useContext(LiveboardContext);

  const stats = channel.email;
  const emailSla = sla.email;
  return (
    <FloorboardRow
      newItems={stats.currentNewEmails}
      activeItems={stats.currentOpenEmails}
      currentWait={stats.currentWait}
      sla={emailSla}
      activeLabel="Open Emails"
      newLabel="New Emails"
      waitLabel="Oldest Unanswered Email"
      icon={<EmailFillIcon />}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/floorboard/email_row.jsx